// src/Time.tsx
import { createIcon } from "@chakra-ui/icon";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var Time_default = createIcon({
  displayName: "Time",
  viewBox: "0 0 24 24",
  path: /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("rect", { opacity: "0", width: "24", height: "24", fill: "white", fillOpacity: "0" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M10 2C9.448 2 9 2.448 9 3C9 3.552 9.448 4 10 4H14C14.552 4 15 3.552 15 3C15 2.448 14.552 2 14 2H10ZM18.9941 4.20508C18.7391 4.22595 18.491 4.34564 18.3125 4.55664C17.9555 4.97764 18.0087 5.6088 18.4297 5.9668L19.8535 7.17383C20.2745 7.53083 20.9057 7.47764 21.2637 7.05664C21.6207 6.63564 21.5675 6.00448 21.1465 5.64648L19.7227 4.43945C19.5122 4.26095 19.2491 4.1842 18.9941 4.20508ZM12 5C7.038 5 3 9.038 3 14C3 18.962 7.038 23 12 23C16.962 23 21 18.962 21 14C21 9.038 16.962 5 12 5ZM12 8C12.552 8 13 8.448 13 9V14C13 14.552 12.552 15 12 15C11.448 15 11 14.552 11 14V9C11 8.448 11.448 8 12 8Z",
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "currentColor"
      }
    )
  ] })
});

export {
  Time_default
};
